import { Fragment } from "react";
import Head from "next/head";
import ViewButton from "../../components/SingleItem/ViewButton";
import SingleProject from "../../components/SingleItem/SingleProject";
import { redirectTo500 } from "../../utils/utility";
import ghost from "../../utils/ghost";
import { getPageDataBySlug } from "../../utils/GhostAPI";
import { useRouter } from "next/router";

export async function getStaticPaths() {
  const allPosts = await ghost({ filter: "tags:blog" });
  const paths = allPosts.posts.map(post => ({
    params: { slug: post.slug },
  }));

  return {
    paths: paths,
    // fallback: true,
    fallback: "blocking",
  };
}

export async function getStaticProps(context) {
  const slug = context.params.slug;
  const post = await getPageDataBySlug(slug);
  if (!post) {
    return redirectTo500();
  }
  return { props: { post } };
}

const SingleBlogDetails = props => {
  const router = useRouter();
  if (router.isFallback) {
    return <div>Loading...</div>;
  }
  return (
    <Fragment>
      <Head>
        <title>Blogs | {props.post.title}</title>
        <meta charset="utf-8" />
        <meta name="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta name="description" content={props.post.excerpt} />
        <meta name="keywords" content="DSi,Software Company in Bangladesh" />
        <meta property="og:title" content={props.post.title} />
        {/* <meta property="og:type" content="website" /> */}
        <meta property="og:type" content="article" /> 
        <meta property="og:description" content={props.post.excerpt} />
        <meta property="og:image" content={props.post.feature_image} />
        {/* <meta property="og:url" content="https://www.dsinnovators.com" /> */}
        <meta property="og:url" content={`https://www.dsinnovators.com/blogs/${props.post.slug}`} />
        <meta property="twitter:title" content={props.post.title} />
        <meta property="twitter:creator" content="...author_name..." />
        <meta property="twitter:description" content={props.post.excerpt} />
        <meta property="twitter:image" content={props.post.feature_image} />
        {/* <link rel="canonical" href="https://www.dsinnovators.com" /> */}
        <link rel="canonical" href={`https://www.dsinnovators.com/blogs/${props.post.slug}`} />
      </Head>
      <div className="mid-home-column mx-auto">
        <div className="mt-16 mb-28 mx-5 md:mx-16">
          <SingleProject post={props.post} path="/blogs/" />
          <div className="grid">
            <div className="mt-9 flex">
              <ViewButton path="/blogs/" title="SEE ALL BLOGS" />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SingleBlogDetails;
